<template>
  <div class="d-flex flex-wrap mb-4">
    <div class="mt-3 d-flex">
      <template v-for="prop in imageProps">
        <div class="phywe-icon-up">
          <img v-if="prop.selectionId === 390" src="https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/SingleArticleIcons/icon-cobra-4.jpg" v-tooltip data-toggle="tooltip" data-placement="top" title="COBRA 4">
          <img v-if="prop.selectionId === 391" src="https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/SingleArticleIcons/icon-tess.jpg" v-tooltip data-toggle="tooltip" data-placement="top" title="TESS">
          <img v-if="prop.selectionId === 392" src="https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/SingleArticleIcons/icon-demo.jpg" v-tooltip data-toggle="tooltip" data-placement="top" title="DEMO">
          <img v-if="prop.selectionId === 393" src="https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/SingleArticleIcons/icon-cobra-smar-tsense.jpg" v-tooltip data-toggle="tooltip" data-placement="top" title="COBRA Smart Sense">
          <img v-if="prop.selectionId === 442" src="https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/SingleArticleIcons/icon-add-set.jpg" v-tooltip data-toggle="tooltip" data-placement="top" title="Aufbauset">
          <img v-if="prop.selectionId === 443" src="https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/SingleArticleIcons/icon-basic-set.jpg" v-tooltip data-toggle="tooltip" data-placement="top" title="Basisset">
          <img v-if="prop.selectionId === 435" src="https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/SingleArticleIcons/icon-nobel.jpg" v-tooltip data-toggle="tooltip" data-placement="top" title="Nobelpreisexperiment">
          <img v-if="prop.selectionId === 1" src="https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/SingleArticleIcons/icon-digital.jpg" v-tooltip data-toggle="tooltip" data-placement="top" title="Digital">
          <img v-if="prop.selectionId === 2" src="https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/SingleArticleIcons/icon-analog.jpg" v-tooltip data-toggle="tooltip" data-placement="top" title="Analog">
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default
{
  props:
  {
    singleprops:
    {
      type: Array,
      default: []
    }
  },
  computed:
      {
        imageProps: function()
        {
          let itemProperties = this.singleprops;
          let returnProps = [];
          for(let i = 0; i < itemProperties.length; i++)
          {
            if(itemProperties[i].id === 1)
            {
              if(itemProperties[i].properties.length > 0)
              {
                for(let i2 = 0; i2 < itemProperties[i].properties.length; i2++)
                {
                  if(itemProperties[i].properties[i2].id === 103)
                  {
                    returnProps = itemProperties[i].properties[i2].values
                  }
                }
              }
            }
          }
          return returnProps;
        }
      }
}
</script>
